module.exports = __webpack_public_path__ + "img/Wp_2050.05d1f951.png";